import { ScreenResourceEvent } from '@bighealth/analytics';

import { UIEventCreator } from 'lib/api/reactQueryHelpers/useLazyQueries/useLazyQueryFireUIEvent';

import { VisualState } from '../../types';

import { AREA } from './constants';

const section = `${AREA}--state`;
export const visualStateScreenEventFactory = (
  visualState: VisualState
): UIEventCreator =>
  async function uiEventCreator(args): Promise<[ScreenResourceEvent]> {
    return [
      {
        occurred_at: args.occurredAt,
        product_id: args.productId,
        program_id: args.programId,
        action: 'viewed',
        name: `screen|viewed|${section}--${visualState}`,
        resource: 'screen',
        version: '1.0.0',
        type: 'ui',
        body: {
          fields: {
            feature: {
              area: AREA,
              section,
            },
            route: args.url.pathname,
          },
          relations: {
            scene_set_graph: { id: args.sceneSetGraphId },
          },
          meta: {
            http: {
              current_url: args.url.href,
              referrer: args.url.href,
              user_agent: args.userAgent,
              client_app_node_package_version: args.clientAppNodePackageVersion,
              product_stream_version: args.productVersionStream,
            },
          },
        },
      },
    ];
  };
